import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import WebServerProvider from "./providers/WebServerProvider";
import "./tailwind-dist.css";
import ReduxProvider from "./providers/reduxProvider";
import { auth0Config } from "./providers/auth0-instance";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Auth0Provider {...auth0Config}>
    <WebServerProvider>
      <ReduxProvider>
        <App />
      </ReduxProvider>
    </WebServerProvider>
  </Auth0Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
